import { render, staticRenderFns } from "./VgvForm.vue?vue&type=template&id=11b4e46e&"
import script from "./VgvForm.vue?vue&type=script&lang=js&"
export * from "./VgvForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b4e46e')) {
      api.createRecord('11b4e46e', component.options)
    } else {
      api.reload('11b4e46e', component.options)
    }
    module.hot.accept("./VgvForm.vue?vue&type=template&id=11b4e46e&", function () {
      api.rerender('11b4e46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/vgv/VgvForm.vue"
export default component.exports